import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { submit } from "redux-form";
import { Modal, ModalBody } from "reactstrap";
import EditProfileForm from "../../forms/EditProfileForm";
import "./styles.scss";

class EditProfileModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    const { buttonClass, buttonLabel, profile, submitForm } = this.props;
    return (
      <React.Fragment>
        <a
          className={`dropdown-menu-link ${buttonClass}`}
          onClick={this.toggle}
        >
          {buttonLabel}
        </a>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          id="edit-profile-modal"
          className={this.props.className}
          size="lg"
        >
          <ModalBody className="edit-profile-modal-body">
            <EditProfileForm
              initialValues={profile}
              slug={profile.slug}
              toggleModal={this.toggle}
              remoteSubmit
            />
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

EditProfileModal.propTypes = {
  buttonClass: PropTypes.string,
  buttonLabel: PropTypes.string,
  profile: PropTypes.object
};

function mapDispatchToProps(dispatch) {
  // Bind an action, which submit the form by its name
  return bindActionCreators(
    {
      submitForm: () => submit("EditProfileForm")
    },
    dispatch
  );
}

export default connect(
  ({ profile }) => ({ profile: profile.profile }),
  mapDispatchToProps
)(EditProfileModal);



// WEBPACK FOOTER //
// ./src/components/modals/EditProfileModal/EditProfileModal.jsx